import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';
import { IPageRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IPageRequirementsTemplate';
import { IRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IRequirementsTemplate';
import { IRequirementsTemplateUpdate } from 'APIPackage/AccountModule/interfaces/IRequirementsTemplateUpdate';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiDelete, apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';

export interface IFetchRequirementTemplatesParams extends IPaginationParams {
  needRequirements?: boolean;
  knoOrganizationId?: number;
  knmSupervisionTypeId?: number;
}

export async function fetchRequirementTemplates({
  needRequirements,
  knoOrganizationId,
  knmSupervisionTypeId,
  ...paginationParams
}: IFetchRequirementTemplatesParams): Promise<IPageRequirementsTemplate> {
  const queryParams = createPaginationParams(paginationParams);

  knoOrganizationId && queryParams.append('knoOrganizationId', knoOrganizationId.toString());
  knmSupervisionTypeId && queryParams.append('knmSupervisionTypeId', knmSupervisionTypeId.toString());
  needRequirements && queryParams.append('needRequirements', needRequirements.toString());

  return apiGet<IPageRequirementsTemplate>(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/requirement-templates${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
  );
}

export async function fetchRequirementTemplate(id: number): Promise<IRequirementsTemplate> {
  return apiGet<IRequirementsTemplate>(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/requirement-templates/${id}`,
  );
}

interface IFetchRequirementTemplateUpdate {
  data: IRequirementsTemplateUpdate;
}

export async function fetchRequirementTemplateUpdate({
  data,
}: IFetchRequirementTemplateUpdate): Promise<IRequirementsTemplate> {
  return apiPost<IRequirementsTemplate>({
    url: `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/requirement-templates`,
    body: data,
  });
}

export async function fetchRequirementTemplateSetDefault(id: number): Promise<IRequirementsTemplate> {
  return apiPost<IRequirementsTemplate>({
    url: `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/requirement-templates/${id}/default`,
  });
}

export async function fetchRequirementTemplateDelete(id: number): Promise<IRequirementsTemplate> {
  return apiDelete<IRequirementsTemplate>(
    `${getServiceBaseURL(APIServiceEnum.DEFAULT_SERVICE)}/requirement-templates/${id}`,
  );
}
